<template>
  <button
    class="w-10 h-10 flex items-center justify-center border border-googlegray rounded cursor-pointer hover:bg-gray-05 transition-colors"
    :aria-label="$t('log_in_facebook')"
    @click="facebookLoginByRedirect"
  >
    <nd-img class="w-4.5 h-4.5" src="/images/facebook-circle.png" />
  </button>
</template>

<script setup lang="ts">
import { QueryStringKeys } from '@/constants/commons'

const config = useRuntimeConfig()

function facebookLoginByRedirect() {
  const route = useRoute()
  const redirectTo = useCookie('RedirectTo', { path: '/', maxAge: 60 })
  redirectTo.value = JSON.stringify({ redirectUrl: route.query[QueryStringKeys.REDIRECT_URL], fallback: window.location.pathname })

  const fbLoginUrl = `https://www.facebook.com/v22.0/dialog/oauth?client_id=${config.public.fbAppId}&redirect_uri=${window.location.origin}/auth/fb-login&scope=email&public_profile&response_type=token`
  location.href = fbLoginUrl
}
</script>
